import { Tooltip } from 'antd';

const enumMap = {
  // 2. 计算方式值说明
  'STANDARD': '直接定价（价格导入）',
  'GENERAL_ITEM': '直接定价（通项导入）',
  'CALCULATE': '利率计算',
  // 3. 价格类型
  'PURCHASE_PRICE': '采购价',
  'MARKET_PRICE': '市场价',
  'PROJECT_MANAGER_PRICE': '项目经理价',
  'CUSTOMER_PRICE': '客户价',
  'SEND_PACK_PRICE': '发包价',
  'SALE_PRICE': '销售指导价',
}

export const config = {
  rowSelection: false,
  pagination: false,
  columns: [
    {
      title: '门店',
      dataIndex: 'companyName',
      width: 250,
      name: 'companyName',
    },
    {
      title: '产品SKU名称',
      dataIndex: 'itemName',
      width: 250,
      name: 'itemName',
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '产品采购价（元）',
      dataIndex: 'purchasePrice',
      width: 150,
      name: 'purchasePrice',
      auth: 'productPriceQuery_purchasePrice',
    },
    {
      title: '市场价（元）',
      dataIndex: 'marketPrice',
      width: 150,
      name: 'marketPrice',
      auth: 'productPriceQuery_marketPrice',
    },
    {
      title: '项目经理价（元）',
      dataIndex: 'projectManagerPrice',
      width: 150,
      name: 'projectManagerPrice',
      auth: 'productPriceQuery_projectManagerPrice',
    },
    {
      title: '项目经理价取值来源',
      dataIndex: 'projectManagerPriceType',
      width: 150,
      name: 'projectManagerPriceType',
      render: (text) => (<span>{enumMap[text]}</span>),
      auth: 'productPriceQuery_projectManagerPrice',
    },
    {
      title: '项目经理利率（%）',
      dataIndex: ['projectManagerPriceInfo', 'rate'],
      width: 150,
      name: 'projectManagerPriceInfo',
      render: (text) => (<span>{ (text || text === 0) ? text : '默认0'}</span>),
      auth: 'productPriceQuery_projectManagerPrice',
    },
    {
      title: '客户价（元）',
      dataIndex: 'customerPrice',
      width: 150,
      name: 'customerPrice',
      auth: 'productPriceQuery_customerPrice'
    },
    {
      title: '客户价取值来源',
      dataIndex: 'customerPriceType',
      width: 150,
      name: 'customerPriceType',
      render: (text) => (<span>{enumMap[text]}</span>),
      auth: 'productPriceQuery_customerPrice'
    },
    {
      title: '毛利率（%）',
      dataIndex: ['customerPriceInfo', 'rate'],
      width: 150,
      name: 'customerPriceInfo',
      auth: 'productPriceQuery_customerPrice',
    },
    {
      title: '发包价（元）',
      dataIndex: 'sendPackPrice',
      width: 150,
      name: 'sendPackPrice',
      auth: 'productPriceQuery_sendPackPrice'
    },
    {
      title: '发包价取值来源',
      dataIndex: 'sendPackPriceType',
      width: 150,
      name: 'sendPackPriceType',
      render: (text) => (<span>{enumMap[text]}</span>),
      auth: 'productPriceQuery_sendPackPrice'
    },
    {
      title: '提点率（%）',
      dataIndex: ['sendPackPriceInfo', 'rate'],
      width: 150,
      name: 'sendPackPriceInfo',
      auth: 'productPriceQuery_sendPackPrice',
    },
    {
      title: '报错信息',
      dataIndex: 'errorMessages',
      width: 550,
      name: 'errorMessages',
      render: (error: any) => (<div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
        <Tooltip
          overlayStyle={{ maxWidth:600 }}
          title={
            <>
              {error?.map(item => (<div>{ item.errorMessage }</div>))}
            </>
          }
        >
          <span style={{ color: 'red' }}>{error?.map(item => item.errorMessage)?.join(',')}</span>
        </Tooltip>
      </div>),
    },
    {
      title:'操作',
      dataIndex: 'action',
      render:'actionRender',
      width:150,
      fixed:'right'
    }
  ],
  search: [
  ],
  footer: [
  ],
}
